import React from "react";
import { Card, Form } from "semantic-ui-react";
import styled from "styled-components";

const StyledDescription = styled(Card.Description)`
  margin: 15px 0 15px 0;
  height: 60px;
`;

const EditableDescription = styled(Card.Description)`
  margin: 12px 0 7px 0;
  height: 72px;
`;

interface Props {
  content: any;
  isCardEditable: boolean;
  onChange: (content: string) => void;
}

const EditableCardField: React.FC<Props> = ({
  content,
  isCardEditable,
  onChange,
}) => {
  return (
    <React.Fragment>
      {isCardEditable ? (
        <EditableDescription>
          <Form.Input
            fluid
            size="mini"
            type="text"
            placeholder={content}
            onChange={(e) => onChange(e.currentTarget.value)}
          />
        </EditableDescription>
      ) : (
        <StyledDescription>{content}</StyledDescription>
      )}
    </React.Fragment>
  );
};

export default EditableCardField;
